import React from 'react'

// Deps
import { redirect } from 'controllers/navigator'

// Sections
import CommerceOrderList from 'views/admin/sections/commerce-order-list'
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Hooks
import useQuery from 'hooks/query'

const defaultQuery = {
	page: '1',
	price_type_id: '0',
	sort_by: 'created_at',
	search_value: '',
	status_code: '',
	product_status: '0',
}

const CommerceOrders = (props) => {
	const queryString = props.match.params.query;

	const [query, urlQuery, filtersOpen] = useQuery(queryString, defaultQuery, ['page', 'search_value']);

	const search = (formData) => {
		let newQuery = [];

		for(const param in formData) {
			if(defaultQuery[param] !== formData[param]) {
				newQuery.push(param + '=' + formData[param]);
			}
		}

		redirect('commerceOrders', { query: newQuery.join('&') });
	}

	const paginate = (page) => {
		let newQuery = {...urlQuery, page: page.toString()};
		if(page === 1) { delete newQuery.page; }

		search(newQuery);
	}

	return (
		<main className="page orders">
			<Breadcrumbs />
			<CommerceOrderList
				onSearch={search}
				onPaginate={paginate}
				initialFiltersOpen={filtersOpen}
				query={query} />
		</main>
	)
}

export default CommerceOrders
